import React from "react";
import { useParams } from "react-router-dom";
import ClientSettings from "../ClientSettings";
import TeamsSettings from "./TeamsSettings";
import IntegrationsSettings from "./IntegrationsSettings";
import BillingSettings from "./BillingSettings";
import ApiKeysSettings from "./ApiKeysSettings";
import { usePermissions } from "../../hooks/usePermissions";

const ALL_TABS = [
  {
    key: "workspace",
    label: "Workspace",
    description: "Manage workspace settings, account profile, and password.",
  },
  {
    key: "integrations",
    label: "Integrations",
    description: "Connect voice platforms and configure notification channels.",
  },
  {
    key: "teams",
    label: "Teams",
    description: "Manage team members, roles, and invitations.",
    requiresAdmin: true,
  },
  {
    key: "api_keys",
    label: "API Keys",
    description: "Manage API keys for programmatic access.",
    requiresAdmin: true,
  },
  {
    key: "billing",
    label: "Billing",
    description: "Manage your subscription and billing details.",
    requiresAdmin: true,
  },
];

const Settings = () => {
  // Each settings section is its own route: /settings/<section>. Billing is a
  // separate page (Billing.js) on its own route, so it never reaches here.
  const { section } = useParams();
  const { isAdmin, isInternalAdmin } = usePermissions();

  const tabs = ALL_TABS.filter((t) => {
    if (t.requiresInternalAdmin && !isInternalAdmin) return false;
    if (t.requiresAdmin && !isAdmin) return false;
    return true;
  });
  const activeTab = section || "workspace";
  const currentTab = tabs.find((t) => t.key === activeTab) || tabs[0];

  return (
    <div className="flex-1 overflow-y-auto p-4">
      <div className="max-w-8xl">
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-foreground">
            {currentTab.label}
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">{currentTab.description}</p>
        </div>

        {activeTab === "workspace" && <ClientSettings />}
        {activeTab === "integrations" && <IntegrationsSettings />}
        {activeTab === "teams" && isAdmin && <TeamsSettings />}
        {activeTab === "api_keys" && isAdmin && <ApiKeysSettings />}
        {activeTab === "billing" && isAdmin && <BillingSettings />}
      </div>
    </div>
  );
};

export default Settings;
